@use '@css/variables';



.obituaries
{
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;

  & > div > a {
    height: 100%;
  }

}

@media only screen and (min-width: variables.$sm-breakpoint) {
    .obituaries
    {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media only screen and (min-width: variables.$md-breakpoint) {
  .obituaries
  {
    grid-template-columns: repeat(3, 1fr);
  }
}


@media only screen and (min-width: variables.$lg-breakpoint) {
  .obituaries
  {
    grid-template-columns: repeat(4, 1fr);
  }
}


//.adSticky {
// display: none;
//}
@media only screen and (min-width: 768px) {
  .adBetween
  {
    display: none;
  }

  .adSticky {
    display: block;
  }
}
